<template>
  <div>
    <section>
      <el-row>
        <el-col :span="2"> 
             <img class="avatar" :src="avatar?avatar:require('../../assets/avatar.png')"  min-width="100" height="100" />
        </el-col>
        <el-col :span="4">
            <el-col :span="24" style="margin-top: 10px;">
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                    <span style="font-size: 25px;">{{ couponName }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 16px;color: #848181;">{{ shopName }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
        <el-col :span="16" style="height:1px">
        </el-col>
        <el-col :span="2">
            <el-col :span="24" style="margin-top: 10px;">
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                     <span style="font-size: 16px;color: #848181;">核销人数</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 28px;">{{ useNum }}人</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
      </el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
        <el-form :inline="true">
          <el-form-item class="form-class">
            <el-input v-model="nickname" placeholder="请输入领券人" clearable></el-input>
          </el-form-item>
          <el-form-item class="form-class">
            <el-button type="primary" v-on:click="getFilterList">查询</el-button>
          </el-form-item >
          <el-form-item class="form-class">
            <el-button type="default" >重置</el-button>
          </el-form-item >
          <el-form-item class="form-class">
            <el-select v-model="sortMethod" placeholder="请选择" @change="verifyChanged">
              <el-option
                v-for="item in sortOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table stripe align="left" :data="tableData" highlight-current-row v-loading="listLoading"
                style="width: 100%;">
        <el-table-column align="center" prop="operateTime" label="核销时间" 
                  min-width="25%"></el-table-column>
        <el-table-column align="center" prop="couponCode" label="券码" min-width="25%"></el-table-column>
        <el-table-column align="center" prop="verifyUsername" label="核销人" min-width="25%"></el-table-column>
        <el-table-column align="center" prop="useUsername" label="使用人" min-width="25%"></el-table-column>
        <el-table-column prop="avatar" label="头像" min-width="25%">
          <template slot-scope="image">
                      <img class="avatar" :src="image.row.avatar?image.row.avatar:require('../../assets/avatar.png')"  min-width="70" height="70" />
                  </template>
        </el-table-column>

      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page=currentPage
        :page-sizes="[10, 20, 30, 40]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </section>
  </div>
</template>

<script>
  export default {
		watch: {
			'$route.query.id'(val) {
				this.getList(0)
			}
		},
    data() {
      return {
        isShow:false,
        values: [],
        tableDate: null,
        listLoading: false,
        totalAmount: 0,
        avatar:null,
        currentPage: 0,
        pageSize: 10,
        total: 0,
        sortOptions:[{ label: '领取时间升序', value: 'operate_time ASC' }, { label: '领取时间降序', value: 'operate_time DESC' }],
        propsData:{},
        couponName:'',
        shopName :'',
        sortMethod:'',
        nickname:'',
        useNum:0,
        tableData:[]
      }
    },

    methods: {
      formatTime(row, column) {
        if (!row.createTime) {
          return '';
        }
        return new Date(row.createTime).format("yyyy/MM/dd hh:mm");
      },

      getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
			},
      handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage - 1);
      },
      handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage - 1);
      },
      async getList(index) {
				let condition = {}
				condition.couponId = this.couponId;
        condition.currentPage = index;
        condition.pageSize = this.pageSize;
        condition.sort = this.sortMethod;
        condition.nickname =this.nickname;
				try{
					this.listLoading = true;
					let result = await this.$http.post(this,'/coupon/getVerifiCouponListByCouponId', {},condition);
					if (result && result.code == 200) {
            
						this.tableData = result.data.rows;
						this.total = result.data.total
						this.listLoading = false;
					}
				} catch(e){
					this.listLoading = false;
				}
			},
      verifyChanged(){
        this.getList(0)
      }
    },
    created() {
      this.couponId = this.$route.query.couponId;
      this.shopName = this.$route.query.shopName;
      this.couponName = this.$route.query.couponName;
      this.avatar = this.$route.query.avatar;
      this.useNum =   this.$route.query.useNum;
      this.listLoading = true
      this.getList(0);
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;
  }

  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }
  .avatar{
      border-radius: 40px;
  }
</style>
